import NagAlert from "components/NagAlert";
import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useConfigPermission } from "context/useConfigPermission";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { PromoItemProps, WebshopId } from "models/WebShop";
import { Link, useParams } from "react-router-dom";
import { isExtraLinkConfigEmpty } from "utility/ProductUtility";
import { UrlPath } from "utility/routes";

const ExtraLinksPromo = ({showBuyPromo = true} : PromoItemProps) => {
    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();
    const { saleStatusByCompany } = useOrders();
    const { productConfigurationsByCompany } = useProductConfiguration();
    const { canConfig } = useConfigPermission();

    const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.ExtraLinks}`;
    const configPath = `${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.ExtraLinks}`;

    if (companyId === "" || companySaleCheck[companyId] === undefined)
        return null;

    const config = productConfigurationsByCompany[companyId];
    if (!config) return null;


    const showSalePromo = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses.some(x => x.activeProducts.some(p => p.id === WebshopId.extraLink)) && productConfigurationsByCompany[companyId]?.extraLinks === null;
    const showConfig = productConfigurationsByCompany[companyId].extraLinks !== undefined && productConfigurationsByCompany[companyId].extraLinks !== null && canConfig(companyId);

     const emptyExtraLinkConfigNag = isExtraLinkConfigEmpty(productConfigurationsByCompany[companyId].extraLinks);

    const nagDescription = "Husk å legge til lenker til din bedrifts viktigste nettsider som for eksempel tjenester, ledige stillinger, kampanjer etc."


    return (showSalePromo && showBuyPromo )  ? (
        <div className="card mt-4">
            <div className="card-header">
                <h2 className="fs-5">Ekstra lenker</h2>
            </div>
            <div className="card-body">
                <Link to={path}><img src="/min-bedrift-ill-lenker.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" style={{ marginTop: 0 }} /></Link>
                <p>Legg til lenker til din bedrifts viktigste nettsider som for eksempel tjenester, ledige stillinger, kampanjer etc.</p>
                <p className="mb-0"><Link to={path} className="btn btn-primary text-white">Kjøp ekstra lenker</Link></p>
            </div>
        </div>
    ) :
        (showConfig ?


            emptyExtraLinkConfigNag ? <NagAlert title="Ekstra Lenker" path={configPath} shTitle="ekstra lenker" description={nagDescription} /> : 

            <div className="card mt-4">
                <div className="card-header">
                    <h2 className="fs-5">Ekstra lenker</h2>
                </div>
                <div className="card-body">
                    <table className="table cc-table-2-col mb-4">
                        <tbody>
                            {productConfigurationsByCompany[companyId].extraLinks?.extraLinks.filter(l => l?.label && l?.url).map((l,i) =>
                            (
                            <tr key={l.label + l.url + i}>
                                <th>{l.label}</th>
                                <td><a href={l.url}>{l.url}</a></td>
                            </tr>)
                            )}
                        </tbody>
                    </table>
                    <div className="mb-0 d-md-flex justify-content-between align-items-center">
                        <div>
                            <Link
                                to={configPath}
                                className="btn btn-primary text-white">Endre ekstra lenker</Link>
                        </div>
                        <div className="mt-3 mt-md-0">
                            <Link
                                to={configPath}
                                className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
                        </div>
                    </div>
                </div>
            </div>
            : null
        )

};

export default ExtraLinksPromo;